import cmp from '../../lib/cmp';
import { smap } from '../../lib/utils';
import onResize from '../../lib/dom/on-resize';
import Siema from '../../vendor/siema';
import priceFormat from '../../lib/price-format';
import styleFactory from '../../lib/dom/style';
import trackInAppView from '../../lib/track-event/in-app-view';
import trackInAppClick from '../../lib/track-event/in-app-click';
import { selectOne } from '../../lib/dom/select-by-class';
import { hasClass } from '../../lib/dom/className';
import viewportSize from '../../lib/dom/viewport-size';
import elementClosest from '../../lib/dom/element-closest';
import './sm-landing-appstore-app-1-purchases.less';
import { isRtl } from '../../lib/document-dir-utils';



const SLIDER_FRAME_CLASS = 'sm-landing-appstore-app-1-purchases__list';
const SLIDE_CLASS = 'sm-landing-appstore-app-1-purchases__list-item';
const IPAD_SIZE = 640;

const subscriptionItem = ($cmp, className) => ({ icon, title, text, price, currency }, index) => `
  <div class="sm-landing-appstore-app-1-purchases__item${isRtl() ? '-rtl' : ''} ${className}" data-index="${index}">
    <div class="sm-landing-appstore-app-1-purchases__item-image${isRtl() ? '-rtl' : ''}">
      <img class="sm-landing-appstore-app-1-purchases__item-image-in" src="${icon.url}"/>
    </div>
    <div class="sm-landing-appstore-app-1-purchases__item-content-info">
      <div class="sm-landing-appstore-app-1-purchases__item-content">
        <div class="sm-landing-appstore-app-1-purchases__item-content-title">${title}</div>
        ${text ? `<div class="sm-landing-appstore-app-1-purchases__item-content-text">${text}</div>` : ''}
      </div>
      <div class="sm-landing-appstore-app-1-purchases__item-button">${priceFormat(price, currency, __('sm@_get'))}</div>
    </div>
  </div>
`;

const template = ($cmp, { inApps, isFeature = false }) => `
  <div class="sm-landing-appstore-app-1-purchases ${isFeature && 'sm-landing-appstore-app-1-purchases--feature'}">
    <div class="sm-landing-appstore-app-1-purchases__h">${__('sm@_in_app_purchases')}</div>
    <div class="sm-landing-appstore-app-1-purchases__list-wr">
      <div class="sm-landing-appstore-app-1-purchases__list">
       ${smap(inApps, subscriptionItem($cmp, SLIDE_CLASS))}
      </div>
    </div>
  </div>
`;



export default cmp(null, template, (element, { inApps, isFeature }) => {
  const padSize = 16;
  const padSizeIpad = 20;

  const viewportWidth = viewportSize.width;
  const viewportHeight = viewportSize.height;
  const isTabletDevice = (viewportWidth >= IPAD_SIZE && viewportHeight >= IPAD_SIZE);

  const style = styleFactory();

  const sliderFrameElement = selectOne(element, SLIDER_FRAME_CLASS);
  const gallery = new Siema(sliderFrameElement, {
    onClick (ev) {
      const slide = elementClosest((element) => hasClass(element, SLIDE_CLASS), ev.target, ev.currentTarget);

      if (!slide) {
        return;
      }

      trackInAppClick(Number(slide.getAttribute('data-index')));
    },
    onChange (index) {
      trackInAppView(index, false);
    }
  });

  if (inApps.length <= 1 || isFeature) {
    gallery.disable();
  }

  if (isTabletDevice && inApps.length <= 2) {
    gallery.disable();
  }

  trackInAppView(0, true);

  return [
    style.destroy,
    gallery.destroy,
    onResize(element, (ev, { width }) => {
      const galleryItemWidth = isTabletDevice ? ((width / 2) - (padSizeIpad / 2)) : (width - (padSize / 2)); //NOTE: calc size of items in gallery list

      style.set(`.${SLIDE_CLASS}{width:${galleryItemWidth}px;}`);
      gallery.refresh();
    }, true)
  ];
});



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-purchases/sm-landing-appstore-app-1-purchases.js